<template>
	<div class="container p-0" style="padding-right: 50px !important;">

		<object-editor-id :item="item.$id" :key="item.$id._htmlId" :disabled="!creation"></object-editor-id>
		
		<object-editor-schema :disabled="disabled" :augment="augment" v-if="type === 'object' && getSchemaItem( ) !== undefined" :item="getSchemaItem( )" :schemas="schemas" :allowed-schemas="allowedSchemas"></object-editor-schema>
		
		<object-editor-item
			v-for="( subItem, subIndex ) in subItems"
			:source="subItems" :key="subItem._htmlId"
			:item="subItem" :index="subIndex" 
			:schemas="schemas" :disabled="disabled"
			:augment="augment">
		</object-editor-item>

		<button v-if="!mySchemaItem.value" @click.prevent="addSubItem({})" class="btn btn-info mt-1">Add Field to Object</button>

	</div>
</template>

<script>
import ObjectEditorItem from "@/components/utilities/ObjectEditorItem";
import ObjectEditorId from "@/components/utilities/ObjectEditorId";

export default {
	name: "object-editor-item-root",
	extends: ObjectEditorItem,
	components:	// Additional components
	{
		ObjectEditorId,
		ObjectEditorItem
	},
	props:	// Additional props
	{
		creation : { type : Boolean, required : false, default : false }
	},
	data() {	// Additional data
		return {
			
		};
	},
	watch:	// Additional watchers
	{
		
	},
	computed:	// Additional getters
	{
		
	},
	mounted( )
	{
		console.warn( "ROOT ITEM CREATED" );
	},
	methods:
	{
		
	}
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/utilities/ObjectEditorItemRoot.vue